// Report definitions API.
//
// Mirrors the Azuro `reportRendering.api` surface, but:
//   - uses plain `fetch` instead of RTK Query
//   - sends the session cookie (`credentials: 'include'`) instead of a Bearer token
//   - does NOT call any Report Scopes endpoints

const BACKEND_URI = process.env.REACT_APP_BACKEND_URI;

const buildQueryString = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

const request = async (path, options = {}) => {
  const response = await fetch(`${BACKEND_URI}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!response.ok) {
    let message = `Request failed with status ${response.status}`;
    try {
      const data = await response.json();
      if (data?.message) message = data.message;
    } catch (_) {
      // ignore
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return null;
  return response.json();
};

/**
 * GET /report-definitions
 * Returns a paged list of report definitions.
 */
export const getReportDefinitions = ({
  pageNumber = 1,
  pageSize = 100,
  sortField = 'reportTitle',
  sortOrder = 'Ascending',
} = {}) =>
  request(
    `/report-definitions${buildQueryString({
      pageNumber,
      pageSize,
      sortField,
      sortOrder,
    })}`,
  );

/**
 * GET /report-definitions/{id}
 * Returns a single report definition.
 */
export const getReportDefinitionById = (reportId) =>
  request(`/report-definitions/${reportId}`);
